import api from "./api";

/**
 * Obter logs de atividade com opções de filtro e paginação
 * @param {Object} options - Opções de filtragem e paginação
 * @returns {Promise} Promise com os logs e informações de paginação
 */
export const getActivityLogs = async (options = {}) => {
  const {
    userId,
    action,
    entityType,
    entityId,
    startDate,
    endDate,
    page = 1,
    limit = 20,
  } = options;

  const queryParams = new URLSearchParams();

  if (userId) queryParams.append("userId", userId);
  if (action) queryParams.append("action", action);
  if (entityType) queryParams.append("entityType", entityType);
  if (entityId) queryParams.append("entityId", entityId);
  if (startDate) queryParams.append("startDate", startDate);
  if (endDate) queryParams.append("endDate", endDate);
  queryParams.append("page", page);
  queryParams.append("limit", limit);

  const response = await api.get(`/api/logs?${queryParams.toString()}`);
  return response.data;
};
